import {SET_CLIENT_DATA, START_PAYMENT_SERVICE,FINISH_LOADING} from "../actions/type";

export const initialState = {
    isLoading: false,
    clientData: null,
    alreadyPaid:[]
}

export default function (state = initialState, action) {
    switch(action.type){
        case START_PAYMENT_SERVICE:
            return {...state, isLoading: true};
        case SET_CLIENT_DATA:
            return {...state, clientData: action.payload};
        case "ALREADY_PAID":
            return {...state, alreadyPaid:action.payload}
        case FINISH_LOADING:
            return {...state, isLoading:false}
        default: 
            return state;
    }
}
